import React from 'react';
import SingleFeature from '../../components/Feature';

const Feature = () => {
  return (
    <div className="it-feature-area fix pt-120 pb-90">
      <div className="container">
        <div className="row gx-35">
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            <SingleFeature
              icon="flaticon-brain"
              title="Specialized Therapy and Support"
              description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim"
            />
          </div>
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <SingleFeature
              icon="flaticon-idea"
              title="Human Diagnosis and Investigation"
              description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim"
            />
          </div>
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <SingleFeature
              icon="flaticon-artificial-intelligence"
              title="Medical Treatment and Surgical"
              description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Feature;
